import './styles.scss'

export type ExitButtonProps = {
  fontColor?: string
  className?: string
  onClick: () => void
}

const CLASS_NAME = 'exit-button'

export const ExitButton = ({ fontColor, className, onClick }: ExitButtonProps) => {
  return (
    <button
      className={`${CLASS_NAME} ${className}`}
      tabIndex={0}
      onClick={onClick}
      style={{ color: fontColor ? fontColor : '#000' }}
      aria-label='Exit Game'>
        Exit Game
    </button>
  )
}
